import { render, staticRenderFns } from "./hpheader.vue?vue&type=template&id=af3b2c86"
import script from "./hpheader.vue?vue&type=script&lang=js"
export * from "./hpheader.vue?vue&type=script&lang=js"
import style0 from "./hpheader.vue?vue&type=style&index=0&id=af3b2c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports